module.exports = __webpack_public_path__ + "static/media/bellIcon.62552980.svg";